import { render, staticRenderFns } from "./FREPage.vue?vue&type=template&id=6bc74f70&scoped=true&"
import script from "./FREPage.vue?vue&type=script&lang=js&"
export * from "./FREPage.vue?vue&type=script&lang=js&"
import style0 from "./FREPage.vue?vue&type=style&index=0&id=6bc74f70&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bc74f70",
  null
  
)

export default component.exports